module.exports = "https://px.ads.linkedin.com/collect/?pid=4496132&fmt=gif";